import { useMutation, useQuery, useQueryClient } from "react-query";
import { AddService, deleteService, editservice, getService } from "./serviceUrls";

const Get_service = (id) => {
  return useQuery(["serviceList", id], () => getService(id), {
    enabled: !!id,
    staleTime: 0,
    refetchOnMount: "always",
  });
};

const Add_service = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => AddService(data), {
    onSettled: (_d, _e, variables) => {
      queryClient.invalidateQueries(["serviceList", variables?.id]);
    },
  });
};
const Edit_service = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => editservice(data), {
    onSettled: (_d, _e, variables) => {
      queryClient.invalidateQueries(["serviceList", variables?.business_id]);
      // Also bust the public detail cache so the public profile shows updated services
      queryClient.invalidateQueries(["getDetails", variables?.business_id]);
    },
  });
};

const Del_service = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => deleteService(data), {
    onSettled: (_d, _e, variables) => {
      queryClient.invalidateQueries(["serviceList", variables?.business_id]);
    },
  });
};

const useServiceQuery = {
  Get_service,
  Add_service,
  Del_service,
  Edit_service
};

export default useServiceQuery;
